// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".keySelector span{content:\" \";margin:0 2px}.keySelector i{content:\" \";margin:0 1px}.keySelector-button-group button{content:\" \";margin:0 2px}label-key{vertical-align:middle}", ""]);
// Exports
module.exports = exports;
